import { Component, OnInit } from '@angular/core';
import { EnrollmentTransferService, EnrollmentTransferListParams } from '../../services/enrollment-transfer.service';
import { LoadingService } from '../../services/loading.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-enrollment-transfers',
  templateUrl: './enrollment-transfers.component.html',
  styleUrls: ['./enrollment-transfers.component.scss']
})
export class EnrollmentTransfersComponent implements OnInit {
  transfers: any[] = [];

  // Filtros
  searchTerm: string = '';
  projectId: number | null = null;
  fromDate: Date | null = null;
  toDate: Date | null = null;

  // Paginación
  pageNumber: number = 1;
  pageSize: number = 20;
  totalRecords: number = 0;

  constructor(
    private transferService: EnrollmentTransferService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadTransfers();
  }

  loadTransfers(): void {
    const params: EnrollmentTransferListParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize
    };

    if (this.searchTerm) params.searchTerm = this.searchTerm;
    if (this.projectId) params.projectId = this.projectId;
    if (this.fromDate) params.fromDate = this.formatDate(this.fromDate);
    if (this.toDate) params.toDate = this.formatDate(this.toDate);

    this.loadingService.show();
    this.transferService.getPaged(params).subscribe({
      next: (res: any) => {
        if (res.isSuccess && res.data) {
          this.transfers = res.data.data || [];
          this.totalRecords = res.data.totalCount || 0;
        } else {
          this.transfers = [];
          this.totalRecords = 0;
          if (res.errorMessage) {
            this.toastService.showError(res.errorMessage);
          }
        }
        this.loadingService.hide();
      },
      error: (err) => {
        this.transfers = [];
        this.totalRecords = 0;
        this.loadingService.hide();
        this.toastService.showError(err.message || 'Error al cargar las cesiones de cupo');
      }
    });
  }

  onFilterChange(): void {
    this.pageNumber = 1;
    this.loadTransfers();
  }

  onPageChange(event: any): void {
    this.pageNumber = event.page + 1; // PrimeNG es 0-indexed
    this.pageSize = event.rows;
    this.loadTransfers();
  }

  getInitials(firstName: string, lastName: string): string {
    return `${(firstName || '')[0] || ''}${(lastName || '')[0] || ''}`.toUpperCase();
  }

  /** Conteo de cesiones individuales en la página actual (no total backend). */
  countIndividual(): number {
    return (this.transfers || []).filter(t => !t.isCorporate).length;
  }

  /** Conteo de cesiones empresariales en la página actual (no total backend). */
  countCorporate(): number {
    return (this.transfers || []).filter(t => !!t.isCorporate).length;
  }

  /** Fecha de la cesión más reciente visible (formato dd/MM/yy). */
  lastTransferDate(): string {
    if (!this.transfers?.length) return '—';
    const dates = this.transfers
      .map(t => t.transferDate ? new Date(t.transferDate).getTime() : 0)
      .filter(t => t > 0);
    if (!dates.length) return '—';
    const max = Math.max(...dates);
    const d = new Date(max);
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(d.getFullYear()).slice(-2)}`;
  }

  /** Label descriptivo para el KPI de última cesión. */
  lastTransferLabel(): string {
    if (!this.transfers?.length) return 'Sin actividad reciente';
    return 'Más reciente en pantalla';
  }

  private formatDate(date: Date): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  }
}
